import { useEffect, useState } from "react";


const getColorName = (chemoName) => {
    if (chemoName === 'RECOVER') {
        return 'Orange';
    }
    if (chemoName === 'ELEVATE') {
        return 'Yellow';
    }
    if (chemoName === 'MOTIVATE') {
        return 'Green';
    }
    if (chemoName === 'RELAX') {
        return 'LightBlue';
    }
    if (chemoName === 'INDULGE') {
        return 'Purple';
    }
    if (chemoName === 'SLEEP') {
        return 'DarkBlue';
    }
}

// const getValueRange = (value, type) => {
//     value = parseFloat(value.slice(0, -1));

//     // if (type === 'Cannaboids') {
//     //     if (value >= 0 && value < 3.5) {
//     //         return '0.5';
//     //     }
//     //     if (value >= 3.5 && value < 7.0) {
//     //         return '1.0';
//     //     }
//     //     if (value >= 7.0 && value < 10.5) {
//     //         return '1.5';
//     //     }
//     //     if (value >= 10.5 && value < 14.0) {
//     //         return '2.0';
//     //     }
//     //     if (value >= 14.0 && value < 17.5) {
//     //         return '2.5';
//     //     }
//     //     if (value >= 17.5 && value < 21.0) {
//     //         return '3.0';
//     //     }
//     //     if (value >= 21.0 && value < 24.5) {
//     //         return '3.5';
//     //     }
//     //     if (value >= 24.5 && value < 28.0) {
//     //         return '4.0';
//     //     }
//     //     if (value >= 28.0 && value < 31.5) {
//     //         return '4.5';
//     //     }
//     //     if (value >= 31.5 && value < 35.0) {
//     //         return '5.0';
//     //     }
//     //     if (value >= 35.0) {
//     //         return '5.0';
//     //     }
//     // }
//     // if (type === 'Terpenes') {
//     //     if (value >= 0 && value < 0.5) {
//     //         return '0.5';
//     //     }
//     //     if (value >= 0.5 && value < 1.0) {
//     //         return '1.0';
//     //     }
//     //     if (value >= 1.0 && value < 1.5) {
//     //         return '1.5';
//     //     }
//     //     if (value >= 1.5 && value < 2.0) {
//     //         return '2.0';
//     //     }
//     //     if (value >= 2.0 && value < 2.5) {
//     //         return '2.5';
//     //     }
//     //     if (value >= 2.5 && value < 3.0) {
//     //         return '3.0';
//     //     }
//     //     if (value >= 3.0 && value < 3.5) {
//     //         return '3.5';
//     //     }
//     //     if (value >= 3.5 && value < 4.0) {
//     //         return '4.0';
//     //     }
//     //     if (value >= 4.0 && value < 4.5) {
//     //         return '4.5';
//     //     }
//     //     if (value >= 4.5 && value < 5.0) {
//     //         return '5.0';
//     //     }
//     //     if (value >= 5.0) {
//     //         return '5.0';
//     //     }
//     // }

//     if (value >= -3.0 && value < -2.0) {
//         return '0.5';
//     }
//     if (value >= -2.0 && value < -1.0) {
//         return '1.5';
//     }
//     if (value >= -1.0 && value < 0.0) {
//         return '2.0';
//     }
//     if (value >= 0.0 && value < 1.0) {
//         return '2.5';
//     }
//     if (value >= 1.0 && value < 2.0) {
//         return '3.5';
//     }
//     if (value >= 2.0 && value < 3.0) {
//         return '4.0';
//     }
//     if (value == 3.0) {
//         return '5.0';
//     }

//     return '2.5';
// }

const getValueRange = (value) => {
  // Convert value to a number and round to one decimal place
  const number = parseFloat(value).toFixed(1);

  // Parse the rounded number to a float for comparison
  const floatNumber = parseFloat(number);

  // Handle the value range constraints
  if (floatNumber < -3.0) {
    return '-3.0';
  } else if (floatNumber > 3.0) {
    return '3.0';
  } else {
    // Return the formatted number as a string
    return number;
  }
};

const makeFilename = (value, chemoName, type) => {
  const colorName = getColorName(chemoName);
  const valueRange = getValueRange(value);
  return `./${valueRange}${colorName}-.png`;
};



const getImage = (filename) => {
    const images = require.context('../assets/graphPngs', true);
    const imageList = images.keys().map(image => images(image));
    const imageNames = images.keys();
    const imageIndex = imageNames.indexOf(filename);
    return imageList[imageIndex];
}

export const GraphPng = ({ value, chemoName, type, width, height }) => {

    const [gImg, setGImg] = useState(null);

    useEffect(() => {
        setGImg(getImage(makeFilename(value, chemoName, type)));
    })

    return (
        <>
            <img src={gImg} alt={'0.5DarkBlue-'} width={width} height={height} />
        </>
    )
}